import { default as OwaSuiteHeader } from './components/OwaSuiteHeader';
export { OwaSuiteHeader };
import './orchestrators/attachWebPushDiscovery';
//# sourceMappingURL=index.js.map